export default () => ({
  collapsed: localStorage.getItem("sidebar-collapsed") === "true",
  width: parseInt(localStorage.getItem("sidebar-width") ?? "288", 10),

  toggle() {
    this.collapsed = !this.collapsed;
    localStorage.setItem("sidebar-collapsed", String(this.collapsed));
  },

  startResize(e: PointerEvent) {
    const handle = e.currentTarget as HTMLElement;
    handle.setPointerCapture(e.pointerId);
    const startX = e.clientX;
    const startWidth = this.width;

    const onMove = (e: PointerEvent) => {
      const delta = e.clientX - startX;
      this.width = Math.max(200, Math.min(480, startWidth + delta));
    };

    const onUp = () => {
      localStorage.setItem("sidebar-width", String(this.width));
      handle.removeEventListener("pointermove", onMove);
      handle.removeEventListener("pointerup", onUp);
    };

    handle.addEventListener("pointermove", onMove);
    handle.addEventListener("pointerup", onUp);
  },
});
